import api from '../helpers/api';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import * as tagsConstants from '../constants/tags';
import BackendPaths from '../helpers/BackendPaths';
import { getErrorMessage } from '../helpers/Util';

function* fetchTags() {
    try {
        const response = yield call(api, BackendPaths.tags.search.getPath());
        yield put({
            type: tagsConstants.FETCH_TAGS_SUCCESS,
            payload: response,
        });
    } catch (e) {
        const response = yield e.json();
        yield put({
            type: tagsConstants.FETCH_TAGS_FAILURE,
            payload: {
                error: getErrorMessage(response),
            },
        });
        return;
    }
}

function* watchFetchTags() {
    yield takeEvery(tagsConstants.FETCH_TAGS_REQUEST, fetchTags);
}

export default function*() {
    yield all([
        watchFetchTags(),
    ]);
}


// WEBPACK FOOTER //
// ./src/sagas/tagsSaga.js